import { HOST } from 'api/constants';

export const GET_EMPLOYEE = `${HOST}/get_employee`;
